export function validMcpRequestId(value) {
  return typeof value === 'string' && /^[A-Za-z0-9_-]{43}$/.test(value);
}

/** Only the callback reviewed on the consent screen may receive the OAuth code. */
export function checkedMcpCallback(target, reviewedRedirect) {
  const url = new URL(target);
  const reviewed = new URL(reviewedRedirect);
  if (url.origin !== reviewed.origin || url.pathname !== reviewed.pathname || url.username || url.password
    || url.hash || !['https:', 'http:'].includes(url.protocol)
    || (url.protocol === 'http:' && !['127.0.0.1', 'localhost', '[::1]'].includes(url.hostname))) {
    throw new Error('The client callback changed. Restart the connection request in your client.');
  }
  for (const [key, value] of reviewed.searchParams) {
    if (url.searchParams.get(key) !== value) throw new Error('The client callback changed. Restart the connection request in your client.');
  }
  if (['access_token', 'refresh_token', 'jwt', 'token'].some((key) => url.searchParams.has(key))) {
    throw new Error('The client callback could not be verified. Restart the connection request in your client.');
  }
  return url.href;
}
